import React from 'react'
import HeroSection from '../Components/HeroSection'

const AboutPage = () => {
  return (
    <div>
      <HeroSection title="ApnaStore - Humari Dukan" photo="./assets/images/heroimg.jpg"/>
    </div>
  )
}

export default AboutPage
